import React from 'react'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import { FileDeletion, FolderDeletion } from '../actions/assetsAction'
import { useDispatch, useSelector } from 'react-redux'

const FolderMenu = (props) => {
  const dispatch = useDispatch()

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const getAssets = useSelector((state) => state.getAssets)
  const { loading, error, file, folder } = getAssets

  const deletefolder = (id) => {
    // setAnchorElfolder(null)
    console.log('deletefolder', id)
    dispatch(FolderDeletion(id))
  }
  const renamefolder = (id, name) => {
    // setAnchorElfile(null)
    props.setCurrentfolderid(id)
    props.setOpenfoldername(true)
  }
  return (
    <>
      <IconButton
        color='inherit'
        aria-label='open drawer'
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <MoreHorizIcon style={{ color: 'grey' }} />
      </IconButton>
      <Menu
        elevation={0}
        id='long-menu'
        anchorEl={anchorEl}
        keepMounted
        open={open}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setAnchorEl(null)}
      >
        {/* <MenuItem
        //   onClick={() => {
        //     deletefolder(props?.id)
        //     setAnchorEl(null)
        //     console.log('curr id', props?.id) // should be each individual id, but here always "test3"
        //   }}
        >
          Download{' '}
        </MenuItem> */}
        {/* <MenuItem
        //   onClick={() => {
        //     deletefolder(props?.id)
        //     setAnchorEl(null)
        //     console.log('curr id', props?.id) // should be each individual id, but here always "test3"
        //   }}
        >
          Move{' '}
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            setAnchorEl(null)
            renamefolder(props?.id, props?.name)
            console.log('curr id', props?.id) // should be each individual id, but here always "test3"
          }}
        >
          Rename{' '}
        </MenuItem>
        <MenuItem
          onClick={() => {
            deletefolder(props?.id)
            setAnchorEl(null)
            console.log('curr id', props?.id) // should be each individual id, but here always "test3"
          }}
        >
          {' '}
          Delete
        </MenuItem>
      </Menu>
    </>
  )
}

export default FolderMenu
